// extracted by mini-css-extract-plugin
export var discard = "_3s-3";
export var muiTooltipTooltip = "_3s-5";
export var notificationBar = "_3s-2";
export var saveButtonHoverSlotWrapper = "_3s-4";
export var show = "_3s-1";
export var spacer = "_3s-0";